import { FEATURES, PRODUCT_FAMILY, PRODUCTS } from '@/base/constants/authorization'

export const storeManagementAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_STORE_MANAGEMENT },
        },
      },
    },
  ],
}

export const asoOverviewAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_ASO_OVERVIEW },
        },
      },
    },
  ],
}

export const keywordTrackingAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_KEYWORD_TRACKING },
        },
      },
    },
  ],
}

export const keywordOptimizationAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $in: [FEATURES.ACCESS_METADATA_OPTIMIZATION, FEATURES.ACCESS_KEYWORD_OPTIMIZATION] },
        },
      },
    },
  ],
}

export const competitorKeywordsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_COMPETITOR_KEYWORDS },
        },
      },
    },
  ],
}

export const keywordInspectorAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_KEYWORD_INSPECTOR },
        },
      },
    },
  ],
}

export const keywordTrendsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_KEYWORD_TRENDS },
        },
      },
    },
  ],
}

export const keywordTranslatorAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_KEYWORD_TRANSLATOR },
        },
      },
    },
  ],
}

export const creativeAssetHubAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_CREATIVE_MONITORING },
        },
      },
    },
  ],
}

export const asoReportAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_ASO_REPORT },
        },
      },
    },
  ],
}

export const visibilityReportAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    { name: { $eq: PRODUCTS.ASO_BUSINESS } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_VISIBILITY_REPORT },
        },
      },
    },
  ],
}

export const keywordIntelligenceAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $in: [FEATURES.ACCESS_DOWNLOAD_SHARE, FEATURES.ACCESS_KEYWORD_INTELLIGENCE] },
        },
      },
    },
  ],
}

export const appUpdateTimelineAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_APP_UPDATE_TIMELINE },
        },
      },
    },
  ],
}

export const localizationAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_LOCALIZATION },
        },
      },
    },
  ],
}

export const downloadReportAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_IOS_DOWNLOAD_REPORT },
        },
      },
    },
  ],
}
